import(/* webpackMode: "eager" */ "/var/www/InfinityV1/node_modules/.pnpm/next@15.5.7_@babel+core@7.28.5_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/image-component.js");
